import React from 'react';
import BaseNode from '../BaseNode';
import { NodeProps } from '@xyflow/react';

const JoinNode: React.FC<NodeProps<any>> = ({ data, selected, id, type, ...props }) => {
  const icon = (
    <span className="rounded-full w-8 h-8 flex items-center justify-center bg-green-100">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <path d="M8 12h8"></path>
        <path d="M12 8v8"></path>
      </svg>
    </span>
  );
  return (
    <BaseNode
      id={id}
      data={data}
      type={type}
      selected={selected}
      icon={icon}
      label={data?.label || 'Join'}
      subtitle={data?.type || 'Inner Join'}
      className="px-4 py-2"
      {...props}
    />
  );
};

export default JoinNode; 